
  import { Component, Vue, Watch, Prop } from "vue-property-decorator";
  
  @Component
  export default class PackageComparing extends Vue
  {
  
    /**
       * 是否显示
       * @private
       * @returns string
       */
       @Prop({type: Boolean, default: false})
      private value: boolean;
  
      /**
       * 套餐列表
       * @private
       * @returns string
       */
       @Prop({type: Array})
      private orgList: any;
  
      /**
       * 是否显示对比弹框 
       * @private
       * @returns boolean
       */
       private get showPopup(): boolean
      {
          return this.value;
      }
   
  
       /**
       * 返回弹框状态 
       * @private
       */
      private set showPopup(value: boolean)
      {
          this.$emit("input", value);
      }
  
      /**
       * 关闭弹窗
       * @private
       */
       private closePopup() {
          this.$emit("close")
      }
  
    
  }
  